import { Box, TableCell, TableRow } from "@mui/material";
import { DotLegalLink, DotLegalTable, ITableHeader } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import { useUrlProvider } from "../../useUrlProvider";
import FormattedDataCategories from "../../DataControllerRecord/FormattedDataCategories";
import { useDataProcessorRecordStyles } from "./DataProcessorRecord.styles";
import { DataProcessorRecordRow, DataProcessorRecordTableModel } from "./DataProcessorRecord.types";

export interface DataProcessorRecordGroupProps {
    group: DataProcessorRecordTableModel;
}

// One data controller's processing activities, under its name. The record stacks one of these per data controller.
function DataProcessorRecordGroup(props: DataProcessorRecordGroupProps) {
    const { translateString } = useTranslation();
    const { getProcessingActivityOverviewUrl } = useUrlProvider();
    const styles = useDataProcessorRecordStyles();

    // Fixed shares of the width rather than sized to the content, so the columns of the stacked tables line up.
    const headers: Array<ITableHeader<DataProcessorRecordRow>> = [
        { property: "processingActivityName", text: translateString("processingActivity"), align: "left", width: "25%" },
        { property: "dataCategories", text: translateString("dataCategories"), align: "left", width: "25%" },
        { property: "securityMeasures", text: translateString("securityMeasures"), align: "left", width: "30%" },
        { property: "thirdCountryTransfers", text: translateString("recipientsThirdCountry"), align: "left", width: "20%" },
    ];

    return (
        <Box>
            <Box sx={styles.tableHeader}>{props.group.name}</Box>
            <DotLegalTable
                hidePagination
                headers={headers}
                clickableRows={false}
                isLoading={false}
                rowsPerPage={1000}
                data={props.group.rows}
                defaultOrderBy={"processingActivityName"}
                paginationLabelOf={translateString("labelOf")}
                defaultOrder="asc"
                renderRow={(row) => (
                    <TableRow key={row.id}>
                        <TableCell>
                            <DotLegalLink bold linkColor="primary" to={getProcessingActivityOverviewUrl(row.id)}>
                                {row.processingActivityName}
                            </DotLegalLink>
                        </TableCell>
                        <TableCell>
                            <FormattedDataCategories dataCategories={row.dataCategories} />
                        </TableCell>
                        <TableCell>{row.securityMeasures.join(", ")}</TableCell>
                        <TableCell>{row.thirdCountryTransfers.join(", ")}</TableCell>
                    </TableRow>
                )}
            />
        </Box>
    );
}

export default DataProcessorRecordGroup;
